export { default } from "./NotesV2Mspa";
